import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
const items = [{
  name: 'Cooking oil · 1L',
  left: '6 left',
  low: true
}, {
  name: 'Sugar · 500g',
  left: '18 left',
  low: false
}, {
  name: 'Maize flour · 5kg',
  left: '3 left',
  low: true
}, {
  name: 'Rice · 10kg',
  left: '24 left',
  low: false
}];
export function InventoryMock() {
  return <div className="w-full max-w-[330px] rounded-[12px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-797" data-mp="p5mtrwuqa80j">
      <div className="flex items-center justify-between" data-id="element-798" data-mp="1cwjrt6dxysw">
        <p className="text-[14px] font-semibold text-ink" data-id="element-799" data-mp="3tkcv7reu5rhf">Reorder soon</p>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-soft px-2.5 py-1 text-[11px] font-semibold text-brand" data-id="element-800" data-mp="b5c4gy92h1hh">
          <AlertTriangleIcon className="h-3 w-3" aria-hidden="true" data-id="element-801" data-mp="6cso5tizvs8z" />2 low
        </span>
      </div>

      <ul className="mt-3 divide-y divide-canvas-line" data-id="element-802" data-mp="3escgmqbud6mz">
        {items.map(item => <li key={item.name} className="flex items-center justify-between py-2.5" data-id="element-803" data-mp="39ujatyegaen8">
            <span className="text-[13px] text-ink-muted" data-id="element-804" data-mp="3ur5i8cc72z9s">{item.name}</span>
            <span className={`text-[12px] font-semibold ${item.low ? 'text-brand' : 'text-ink-muted'}`} data-id="element-805" data-mp="3lci3q4sl0wp">
              {item.left}
            </span>
          </li>)}
      </ul>

      <button type="button" className="mt-4 w-full rounded-[7px] bg-ink px-4 py-2.5 text-[13px] font-semibold text-white" data-id="element-806" data-mp="dbyu7adav9an">
        Plan purchase
      </button>
    </div>;
}